<template>
	<div class="order-page">

		<!-- ===== 主表单卡片 ===== -->
		<div class="form-card animate__animated  ">
			<!-- 货物信息 -->
			<div class="section-header">
				<el-image :src="require('@/static/CodeBuddyAssets/30856_3166/18.svg')"></el-image>
				<h3 class="section-title">货物信息</h3>
				<div class="add-goods-btn" @click="openAddDialog">
					<el-image :src="require('@/static/CodeBuddyAssets/30856_3166/8.svg')"></el-image>
					<span>添加</span>
				</div>
			</div>
			<!-- 货物列表 -->
			<div class="goods-row">
				
				<div class="address-card address-card-empty" style="width: 7.32rem;" v-if="!goodsList.length">
					<span class="addr-empty-text">请选择货物信息</span>
				</div>
				<div class="goods-card" v-for="(item, idx) in goodsList" :key="idx">
					<div class="gc-top">
						<span class="gc-tracking">快递单号：{{ item.trackingNo }}</span>
						<span class="gc-copy" @click="copyText(item.trackingNo)">复制</span>
						<div class="gc-delete" @click="deleteGoods(idx)">
							<el-image :src="require('@/static/CodeBuddyAssets/30856_3166/13.svg')"></el-image>
							<span>删除</span>
						</div>
					</div>
					<div class="gc-body">
						<el-image class="gc-img" :src="item.img" :preview-src-list="[item.img]" fit="cover"></el-image>
						<div class="gc-info">
							<div class="gc-name">货物名称：{{ item.name }}</div>
							<div class="gc-size">长：{{ item.length||'？' }}cm&nbsp;宽：{{ item.width||'？' }}cm&nbsp;高：{{ item.height||'？' }}cm</div>
							<div class="gc-meta">
								<span>重量：{{ item.weight||'？' }}kg</span>
								<el-image class="meta-dot" :src="require('@/static/CodeBuddyAssets/30856_3166/12.svg')"></el-image>
								<span>体积：{{ item.volume||'？' }}m³</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 收件人/物流方案 -->
			<div class="f-bct">
			<div style="width: 48%;">
			<!-- 收件人 -->
			<div class="section-header">
				<el-image :src="require('@/static/CodeBuddyAssets/30856_3166/18.svg')"></el-image>
				<h3 class="section-title">收件人</h3>
			</div>
			<div class="recipient-row">
				<div class="select-box" @click="openAddrDialog">选择地址</div>
				<div class="address-card" v-if="selectedAddress" @click="openAddrDialog">
					<el-image class="addr-icon" :src="require('@/static/CodeBuddyAssets/30856_3166/16.svg')"></el-image>
					<span class="addr-name">{{ selectedAddress.consignee }}</span>
					<span class="addr-phone">{{ selectedAddress.mobile }}</span>
					<div class="addr-tag" :class="selectedAddress.addressType === 2 ? 'addr-tag-pickup' : 'addr-tag-delivery'">
						{{ selectedAddress.addressType === 1 ? '送货上门' : '自提' }}
					</div>
					<div class="addr-detail">
						<span class="addr-country">{{ selectedAddress.countryName || '--' }}</span>
						<span class="addr-street">{{ selectedAddress.provinceName }}{{ selectedAddress.cityName }}{{ selectedAddress.address }}</span>
					</div>
					<div v-if="selectedAddress.addressType === 2 && selectedAddress.selfPickupSite" class="addr-point">
						{{ selectedAddress.selfPickupSite.name }}
					</div>
					<div v-else class="addr-point">
						{{ selectedAddress.consignee }}
					</div>
				</div>
				<div class="address-card address-card-empty" v-else @click="openAddrDialog">
					<!-- <el-image class="addr-icon" :src="require('@/static/CodeBuddyAssets/30856_3166/16.svg')"></el-image> -->
					<span class="addr-empty-text">请选择收件地址</span>
				</div>
			</div>
			</div>
			<div style="width: 48%;">
				<!-- 物流方案 -->
				<div class="section-header section-header-right">
					<el-image :src="require('@/static/CodeBuddyAssets/30856_3166/18.svg')"></el-image>
					<h3 class="section-title">物流方案</h3>
				</div>
				<div class="logistics-row">
					<div class="select-box" @click="openWlDialog">添加</div>
					<div v-if="wlFaItem" class="logistics-card">
						<el-image class="log-img" :src="wlFaItem.icon || defaultCargoImg" :preview-src-list="[wlFaItem.img || require('@/static/CodeBuddyAssets/30856_3166/43.png')]" fit="cover"></el-image>
						<div class="log-body">
							<div class="log-name">{{ wlFaItem.name }}</div>
							<div class="log-meta">
								<span class="log-duration">{{ wlFaItem.deliveryTime }}</span>
								<div class="meta-sep"></div>
								<span class="log-weight">计费重量：{{ hxMsgAll.totalWeight }}kg</span>
							</div>
							<div class="log-sub" v-if="wlFaItem.calculatePriceMode==1">首重续重</div>
							<div class="log-sub" v-if="wlFaItem.calculatePriceMode==2">阶梯价格</div>
							<div class="log-sub" v-if="wlFaItem.calculatePriceMode==3">多级续重</div>
							<div class="log-sub" v-if="wlFaItem.calculatePriceMode==4">阶梯首重续重</div>
						</div>
						<div class="log-price-area">
							<div class="log-price">
								<span class="log-psymbol">￥</span>
								<span class="log-pvalue">{{ wlFaItem.freightPrice }}</span>
							</div>
							<div class="log-plabel">预估费用</div>
						</div>
						<span class="log-detail">查看详情</span>
					</div>
					<div v-else class="logistics-card logistics-card-empty" style="justify-content: flex-start;" @click="openWlDialog">
						<span class="log-empty-text">请选择物流方案</span>
					</div>
				</div>
			</div>
			</div>

			<!-- 运输信息 -->
			<div class="section-header" style="margin-top: 24px;">
				<el-image :src="require('@/static/CodeBuddyAssets/30856_3166/18.svg')"></el-image>
				<h3 class="section-title">运输信息</h3>
			</div>

			<div class="transport-row">
				<!-- <div class="transport-item">
					<span class="tp-label">报关方式</span>
					<div class="tp-options">
						<div class="tp-radio" :class="{ 'tp-radio-active': customsType === 'all' }" @click="customsType = 'all'">
							<el-image :src="customsType === 'all' ? require('@/static/add2/37.png') : require('@/static/add2/38.png')"></el-image>
							<span>我司全带</span>
						</div>
						<div class="tp-radio" :class="{ 'tp-radio-active': customsType === 'self' }" @click="customsType = 'self'">
							<el-image :src="customsType === 'self' ? require('@/static/add2/37.png') : require('@/static/add2/38.png')"></el-image>
							<span>自单代报</span>
						</div>
					</div>
				</div> -->
				<div class="transport-item">
					<span class="tp-label">增值服务(可多选)</span>
					<div class="tp-select-wrap">
						<el-select v-model="itemCategory" multiple placeholder="请选择（可多选）" class="form-select">
							<el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
				</div>
				<div class="transport-item">
					<span class="tp-label">备注</span>
					<div class="tp-select-wrap">
						<el-input v-model="remark" placeholder="请输入备注" class="remark-input"></el-input>
					</div>
				</div>
				<!-- <div class="transport-item">
					<span class="tp-label">收货方式</span>
					<div class="tp-options">
						<div class="tp-radio" :class="{ 'tp-radio-active': receiveType === 'pickup' }" @click="receiveType = 'pickup'">
							<el-image :src="receiveType === 'pickup' ? require('@/static/add2/37.png') : require('@/static/add2/38.png')"></el-image>
							<span>自提</span>
						</div>
						<div class="tp-radio" :class="{ 'tp-radio-active': receiveType === 'deliver' }" @click="receiveType = 'deliver'">
							<el-image :src="receiveType === 'deliver' ? require('@/static/add2/37.png') : require('@/static/add2/38.png')"></el-image>
							<span>派送</span>
						</div>
					</div>
				</div> -->
			</div>

			<!-- 备注 -->
			<!-- <div class="remark-row">
				<span class="remark-label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注</span>
				<div class="remark-input-wrap">
					<el-input v-model="remark" placeholder="请输入备注" class="remark-input"></el-input>
				</div>
			</div> -->

			<!-- 下单按钮 -->
			<div class="submit-row">
				<div class="order-btn" @click="transportOrdercreateUp">下单</div>
			</div>
			
		</div>

		<!-- ====== 添加货物弹窗 (Figma 30934_7945) ====== -->
		<el-dialog
			:visible.sync="addDialogVisible"
			width="1278px"
			custom-class="add-cargo-popup"
			:show-close="false"
			:close-on-click-modal="true">
			<div slot="title" class="popup-header">
				<h3 class="popup-title">添加货物</h3>
			</div>
			<div class="popup-body">
				<!-- 仓库选项卡 -->
				<div class="popup-tabs">
					<div
						v-for="(w, wIdx) in warehouseList"
						:key="w.id"
						class="popup-tab"
						:class="{ 'popup-tab-active': activeWarehouseIdx === wIdx }"
						@click="switchWarehouse(wIdx)">
						{{ w.name }}
					</div>
				</div>
				<div class="popup-grid" v-if="cargoOptions.length" v-loading="cargoLoading">
					<div
						v-for="opt in cargoOptions"
						:key="opt.id"
						class="popup-card"
						:class="{ 'popup-card-active': selectedCargo.includes(opt.id) }"
						@click="toggleCargo(opt)">
						<div class="pc-top">
							<span class="pc-checkbox" :class="{ 'pc-checked': selectedCargo.includes(opt.id) }">
								<span v-if="selectedCargo.includes(opt.id)" class="pc-check-mark">&#10003;</span>
							</span>
							<span class="pc-tracking">快递单号：{{ opt.trackingNo }}</span>
							<span class="pc-copy" @click.stop="copyText(opt.trackingNo)">复制</span>
						</div>
						<div class="pc-body">
							<el-image class="pc-img" :src="opt.img" :preview-src-list="[opt.img]" fit="cover"></el-image>
							<div class="pc-info">
								<div class="pc-name">货物名称：{{ opt.name||'？' }}</div>
								<div class="pc-size">长：{{ opt.length||'？' }}cm&nbsp;宽：{{ opt.width||'？' }}cm&nbsp;高：{{ opt.height||'？' }}cm</div>
								<div class="pc-meta">
									<span>重量：{{ opt.weight||'？' }}kg</span>
									<el-image class="pc-dot" :src="require('@/static/CodeBuddyAssets/30934_7945/' + (selectedCargo.includes(opt.id) ? '3.svg' : '1.svg'))"></el-image>
									<span>体积：{{ opt.volume||'？' }}m³</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="!cargoLoading && cargoOptions.length === 0" class="popup-empty">
					<el-image style="padding: 0;" :src="require('@/static/zw.svg')"></el-image>
					<p>暂无货物数据</p>
				</div>
			</div>
			<div slot="footer" class="popup-footer">
				<div class="popup-btn btn-cancel" @click="closeAddDialog">返回</div>
				<div class="popup-btn btn-confirm" @click="confirmAddCargo">确定</div>
			</div>
		</el-dialog>

		<!-- 选择地址弹窗 -->
		<el-dialog
			:visible.sync="addrDialogVisible"
			width="1080px"
			custom-class="addr-popup"
			:show-close="false"
			:close-on-click-modal="true">
			<div slot="title" class="popup-header">
				<h3 class="popup-title">选择地址</h3>
			</div>
			<div class="addr-list-wrap" v-loading="addrLoading">
				<div class="addr-empty" v-if="!addrLoading && addrList.length === 0">暂无地址数据</div>
				<div
					v-for="item in addrList"
					:key="item.id"
					class="addr-pick-card"
					@click="pickAddress(item)">
					<el-image class="apc-icon" :src="require('@/static/add2/39.png')"></el-image>
					<div class="apc-body">
						<div class="apc-name">
							<span v-if="item.addressType === 1">{{ item.consignee }}</span>
							<span v-else-if="item.addressType === 2 && item.selfPickupSite">{{ item.selfPickupSite.name }}</span>
							<span v-else>{{ item.consignee }}</span>
							<span class="apc-tag" :class="item.addressType === 2 ? 'apc-tag-pickup' : 'apc-tag-delivery'">
								{{ item.addressType === 1 ? '送货上门' : '自提' }}
							</span>
							<span class="apc-selected-flag" v-if="selectedAddress && selectedAddress.id === item.id">已选</span>
						</div>
						<div class="apc-contact">
							<span>{{ item.consignee }}</span>
							<span>{{ item.mobile }}</span>
						</div>
						<div class="apc-addr">
							<span class="apc-country">{{ item.countryName || '--' }}</span>
							<span>{{ item.provinceName }}{{ item.cityName }}{{ item.address }}</span>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="popup-footer">
				<div class="popup-btn btn-cancel" @click="addrDialogVisible = false">关闭</div>
			</div>
		</el-dialog>

		<!-- 选择物流方案弹窗 -->
		<el-dialog
			:visible.sync="wlDialogVisible"
			width="8rem"
			custom-class="wl-popup"
			:show-close="false"
			:close-on-click-modal="true">
			<div slot="title" class="popup-header">
				<h3 class="popup-title">选择物流方案</h3>
			</div>
			<div class="wl-list-wrap">
				<div class="wl-empty" v-if="wlFa.length === 0">暂无物流方案</div>
				<div
					v-for="item in wlFa"
					:key="item.id"
					class="wl-card"
					:class="{ 'wl-card-active': wlPendingItem && wlPendingItem.id === item.id }"
					@click="pickWl(item)">
					<el-image class="wlc-img" :src="item.icon || defaultCargoImg" fit="cover"></el-image>
					<div class="wlc-body">
						<div class="wlc-name">
							<span>{{ item.name }}</span>
							<span v-if="wlPendingItem && wlPendingItem.id === item.id" class="wlc-selected">已选</span>
						</div>
						<div class="wlc-meta">
							<span>{{ item.deliveryTime }}</span>
							<div class="meta-sep"></div>
							<span>计费重量：{{ hxMsgAll.totalWeight }}kg</span>
						</div>
						<div class="wlc-mode" v-if="item.calculatePriceMode==1">首重续重</div>
						<div class="wlc-mode" v-if="item.calculatePriceMode==2">阶梯价格</div>
						<div class="wlc-mode" v-if="item.calculatePriceMode==3">多级续重</div>
						<div class="wlc-mode" v-if="item.calculatePriceMode==4">阶梯首重续重</div>
					</div>
					<div class="wlc-price-area">
						<div class="wlc-price">
							<span class="wlc-psymbol">￥</span>
							<span class="wlc-pvalue">{{ item.freightPrice }}</span>
						</div>
						<div class="wlc-plabel">预估费用</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="popup-footer">
				<div class="popup-btn btn-cancel" @click="cancelWlDialog">取消</div>
				<div class="popup-btn btn-confirm" :class="{ 'btn-disabled': !wlFaItem }" @click="confirmWlDialog">确定</div>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
import {
	packageGoodsTypeList,
	warehouselist,
	packagelist,
	memberAddresslist,
	appreciationlist,
	transportOrderpreview,
	freightEstimateLineList,
	transportOrdercreate,
} from "/src/api/api.js"
export default {
	name: 'OrderPage',
	data() {
		return {
			customsType: 'all',
			receiveType: 'pickup',
			goodsType: '',
			remark: '',
			// 回显数据
			hxMsgAll:'',
			// 选择商品
			addDialogVisible: false,
			selectedCargo: [],          // 当前弹窗中选中的包裹id数组
			selectedCargoCache: {},     // 选中包裹的完整数据缓存（id -> item），用于回显与确定时取数
			warehouseList: [],          // 仓库选项卡列表
			activeWarehouseIdx: 0,      // 当前选中的仓库选项卡
			cargoLoading: false,        // 货物列表加载状态
			goodsList: [],
			cargoOptions: [],           // 货物列表（接口数据）
			defaultCargoImg: 'https://file.binli-logistics.com/static/icon70.png',
			// 选择地址
			selectedAddress: null,      // 当前选中的收件地址
			addrDialogVisible: false,   // 地址选择弹窗
			addrList: [],               // 地址列表（接口数据）
			addrLoading: false,
			// 所选增值服务
			categoryOptions:[],
			itemCategory:'',
			// 物流方案
			wlFa:[],
			wlFaItem:null,
			wlPendingItem:null,        // 弹窗内当前勾选的待选方案（未点确认前不替换 wlFaItem）
			wlDialogVisible: false,    // 物流方案选择弹窗
		}
	},
	mounted() {
		
		// 包裹带过来的数据
		const goOrderWlStr = localStorage.getItem('goOrderWl');
		const goOrderWl = goOrderWlStr ? JSON.parse(goOrderWlStr) : null;
		// console.log(goOrderWl);
		if(goOrderWl){
			var newGoOrderWl
			newGoOrderWl = (goOrderWl || []).map(item => ({
				packageId: item.id,
				warehouseId: item.warehouse.id ? item.warehouse.id : '',
				img: (item.gallery && item.gallery.length) ? item.gallery[0] : this.defaultCargoImg,
				trackingNo: item.trackingNo,
				name: item.name,
				length: item.length,
				width: item.width,
				height: item.height,
				weight: item.weight,
				value: item.value
			}))
			this.goodsList = newGoOrderWl
			localStorage.removeItem('goOrderWl');
		}
		
		this.loadCategories()
		this.transportOrderpreviewGet()
	},
	methods: {
		// 下单
		async transportOrdercreateUp(){
			
			if(!this.selectedAddress){
				this.Tips('请选择地址')
				return
			}
			
			if(!this.wlFa){
				this.Tips('请选择物流方案')
				return
			}
			
			// 计算长宽高体积
			var length=0;
			var width=0;
			var height=0;
			var volume=0;
			var ids = []
			this.goodsList.forEach((item)=>{
				length += item.length||0
				width += item.width||0
				height += item.height||0
				volume += item.volume||0
				ids.push(item.packageId)
			})
			
			var data = {
				addressId: this.selectedAddress.id,
				appreciationServiceIds:this.itemCategory,
				// customsClearanceType:this.customsClearanceType,
				// deliveryType:this.deliveryType,
				customsClearanceType:1,
				deliveryType:1,
				goodsTypeIds:this.hxMsgAll.goodsTypeIds,
				packageIds:ids,
				remark:this.remark,
				transportLinesId:this.wlFaItem.id,
				length,
				width,
				height,
				volume,
			}
			const res = await transportOrdercreate(data)
			if(res.code==200){
				this.Tips(res.msg)
				this.$router.go(0);
			}else{this.Tips(res.msg,'error')}
		},
		// 立即下单预览
		async transportOrderpreviewGet(){
			var ids = []
			this.goodsList.forEach((item)=>{
				ids.push(item.packageId)
			})
			if(!ids.length){
				return
			}
			var data = {
				packageIds: ids
			}
			const res = await transportOrderpreview(data)
			if(res.code==200){
				this.hxMsgAll = res.data
				// this.packageList = res.data.packageList
				this.selectedAddress = res.data.address
				if(this.selectedAddress){
					this.freightEstimateLineListGet()
				}
			}else{this.Tips(res.msg,'error')}
		},
		// 默认物流方案
		async freightEstimateLineListGet(){
			var wlJisuan = {
				weight:this.hxMsgAll.totalWeight,
				warehouseId:this.hxMsgAll.warehouse.id,
				countryId:this.selectedAddress.countryId
			}
			var data = {
				pageNum: 1,
				pageSize: 999,
				weight:wlJisuan.weight,
				warehouseId:wlJisuan.warehouseId,
				countryId:this.selectedAddress.countryId,
			}
			const res = await freightEstimateLineList(data)
			if(res.code==200){
				this.wlFa = res.rows
				if(res.rows.length){
					this.wlFaItem = res.rows[0]
				}
			}else{this.Tips(res.msg);}
		},
		// 增值服务
		async loadCategories() {
			const res = await appreciationlist({})
			if (res.code == 200) {
				(res.rows || []).forEach(item => {
					item.label = item.name+'('+item.price+')'
					item.value = item.id
				})
				this.categoryOptions = res.rows
			} else {
				this.Tips(res.msg || '品类加载失败', 'error')
			}
		},
		// 打开添加弹窗：从已确认的货物列表回显选中状态，并加载仓库/货物数据
		openAddDialog() {
			// 回显：以 goodsList（上次确认的结果）为准恢复选中状态
			this.selectedCargo = this.goodsList.map(g => g.packageId)
			this.selectedCargoCache = {}
			this.goodsList.forEach(g => {
				this.$set(this.selectedCargoCache, g.packageId, {
					id: g.packageId,
					img: g.img,
					trackingNo: g.trackingNo,
					name: g.name,
					length: g.length,
					width: g.width,
					height: g.height,
					weight: g.weight,
					value: g.value
				})
			})
			this.addDialogVisible = true
			if (this.warehouseList.length) {
				this.restoreWarehouseTab()
				this.loadCargoList()
			} else {
				this.loadWarehouses()
			}
		},
		// 将仓库选项卡定位到已选货物所属的仓库
		restoreWarehouseTab() {
			if (!this.goodsList.length) return
			const wid = this.goodsList[0].warehouseId
			const idx = this.warehouseList.findIndex(w => w.id === wid)
			if (idx > -1) {
				this.activeWarehouseIdx = idx
			}
		},
		// 关闭弹窗（返回按钮）：未确认的改动直接丢弃，下次打开从 goodsList 重新回显
		closeAddDialog() {
			this.addDialogVisible = false
		},
		// 仓库列表
		async loadWarehouses() {
			const res = await warehouselist({})
			if (res.code == 200) {
				this.warehouseList = res.rows || []
				if (this.warehouseList.length) {
					this.activeWarehouseIdx = 0
					this.restoreWarehouseTab()
					this.loadCargoList()
				}
			} else {
				this.Tips(res.msg || '仓库加载失败', 'error')
			}
		},
		// 切换仓库选项卡：自动清除当前已选择的货物
		switchWarehouse(idx) {
			if (this.activeWarehouseIdx === idx) return
			this.activeWarehouseIdx = idx
			this.selectedCargo = []
			this.selectedCargoCache = {}
			this.loadCargoList()
		},
		// 货物列表：按当前仓库查询未绑定运输订单且状态为待入库/已入库的包裹
		async loadCargoList() {
			const warehouse = this.warehouseList[this.activeWarehouseIdx]
			if (!warehouse) {
				this.cargoOptions = []
				return
			}
			this.cargoLoading = true
			try {
				const res = await packagelist({
					warehouseId: warehouse.id,
					unboundTransportOrder: true,
					// statusList: '1,2',
					status:2,
					pageNum: 1,
					pageSize: 999
				})
				if (res.code == 200) {
					this.cargoOptions = (res.rows || []).map(item => ({
						id: item.id,
						img: (item.gallery && item.gallery.length) ? item.gallery[0] : this.defaultCargoImg,
						trackingNo: item.expressNumber || '',
						name: item.name || '',
						length: item.length,
						width: item.width,
						height: item.height,
						weight: item.weight,
						value: item.declaredValue != null ? item.declaredValue : item.value
					}))
				} else {
					this.cargoOptions = []
					this.Tips(res.msg || '货物加载失败', 'error')
				}
			} finally {
				this.cargoLoading = false
			}
		},
		// 切换货物选中/取消（按包裹id）
		toggleCargo(opt) {
			const pos = this.selectedCargo.indexOf(opt.id)
			if (pos > -1) {
				this.selectedCargo.splice(pos, 1)
				this.$delete(this.selectedCargoCache, opt.id)
			} else {
				this.selectedCargo.push(opt.id)
				this.$set(this.selectedCargoCache, opt.id, opt)
			}
		},
		// 确认添加：用当前选中的货物完全替换展示区域已有货物
		confirmAddCargo() {
			if (this.selectedCargo.length === 0) {
				this.Tips('请至少选择一项货物')
				return
			}
			const warehouse = this.warehouseList[this.activeWarehouseIdx]
			const list = []
			this.selectedCargo.forEach(id => {
				const item = this.selectedCargoCache[id]
				if (!item) return
				list.push({
					packageId: item.id,
					warehouseId: warehouse ? warehouse.id : '',
					img: item.img,
					trackingNo: item.trackingNo,
					name: item.name,
					length: item.length,
					width: item.width,
					height: item.height,
					weight: item.weight,
					value: item.value
				})
			})
			// 完全替换，不保留原有货物
			this.goodsList = list
			this.selectedCargo = []
			this.selectedCargoCache = {}
			this.addDialogVisible = false
			this.transportOrderpreviewGet()
		},
		deleteGoods(idx) {
			this.goodsList.splice(idx, 1)
		},
		// 打开地址选择弹窗：首次打开加载地址列表
		openAddrDialog() {
			this.addrDialogVisible = true
			if (!this.addrList.length) {
				this.loadAddrList()
			}
		},
		// 加载地址列表
		async loadAddrList() {
			this.addrLoading = true
			try {
				const res = await memberAddresslist({})
				if (res.code == 200) {
					this.addrList = res.rows || []
				} else {
					this.addrList = []
					this.Tips(res.msg || '地址加载失败', 'error')
				}
			} finally {
				this.addrLoading = false
			}
		},
		// 选中地址：替换当前 selectedAddress 并关闭弹窗
		pickAddress(item) {
			this.selectedAddress = item
			this.addrDialogVisible = false
		},
		// 打开物流方案弹窗：携带当前已选项作为初始待选
		openWlDialog() {
			this.wlPendingItem = this.wlFaItem ? this.wlFaItem : null
			this.wlDialogVisible = true
		},
		// 在弹窗中点选某个方案（仅更新待选状态，未替换 wlFaItem）
		pickWl(item) {
			this.wlPendingItem = item
		},
		// 取消：保留原 wlFaItem 不变
		cancelWlDialog() {
			this.wlPendingItem = null
			this.wlDialogVisible = false
		},
		// 确认：将待选方案替换 wlFaItem 并关闭弹窗
		confirmWlDialog() {
			if (!this.wlPendingItem) {
				this.Tips('请先选择一项物流方案')
				return
			}
			this.wlFaItem = this.wlPendingItem
			this.wlPendingItem = null
			this.wlDialogVisible = false
		},
		copyText(text) {
			navigator.clipboard.writeText(text)
		},
	}
}
</script>

<style lang="scss" scoped>
.order-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 60px;
}
::v-deep .el-dialog{
	width: 1278px!important;
}
::v-deep .el-dialog__body{
	padding: 0;
}
::v-deep .el-dialog__header{
	padding: 0;
}
/* ===== 页面顶部条 ===== */
.page-top-bar {
	width: 1596px;
	height: 88px;
	background: #fff;
	border-radius: 12px;
	margin: 24px auto 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 32px;
	box-sizing: border-box;
}
.welcome-text {
	display: flex;
	align-items: baseline;
}
.wel-gray {
	font-size: 20px;
	color: #666;
	font-weight: 400;
}
.wel-blue {
	font-size: 20px;
	color: #0096FF;
	font-weight: 500;
	margin-left: 4px;
}
.top-actions {
	display: flex;
	align-items: center;
}
.lang-text {
	font-size: 16px;
	font-weight: 500;
	color: #333;
}
.action-gap {
	width: 1px;
	height: 18px;
	margin: 0 16px;
}
.user-name {
	font-size: 18px;
	color: #333;
	margin-left: 8px;
}
.member-no {
	font-size: 18px;
	color: #989FAC;
	margin-left: 8px;
}
.cart-badge {
	margin-left: -6px;
	margin-bottom: 12px;
	width: 10px;
	height: 10px;
}

/* ===== 主表单卡片 ===== */
.form-card {
	width: 1596px;
	margin: 12px auto 0;
	background: #fff;
	border-radius: 12px;
	padding: 24px 32px 40px;
	box-sizing: border-box;
	margin-top: 24px;
}

/* ===== 节标题 ===== */
.section-header {
	display: flex;
	align-items: center;
	margin-bottom: 24px;
}
.section-header .el-image {
	width: 4px;
	height: 16px;
	margin-right: 12px;
}
.section-title {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin: 0;
	flex: 1;
}
.add-goods-btn {
	display: flex;
	align-items: center;
	width: 86px;
	height: 32px;
	border: 1px solid #0096FF;
	border-radius: 6px;
	cursor: pointer;
	justify-content: center;
}
.add-goods-btn .el-image {
	width: 14px;
	height: 14px;
	margin-right: 4px;
}
.add-goods-btn span {
	font-size: 14px;
	color: #0096FF;
}

/* ===== 货物卡片 ===== */
.goods-row {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 20px;
}
.goods-card {
	width: 748px;
	height: 156px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 12px;
	padding: 20px 24px;
	box-sizing: border-box;
	margin-right: 24px;
	margin-bottom: 16px;
}
.goods-card:nth-child(even) {
	margin-right: 0;
}
.gc-top {
	display: flex;
	align-items: center;
}
.gc-tracking {
	font-size: 14px;
	color: #333;
}
.gc-copy {
	font-size: 14px;
	color: #0096FF;
	margin-left: 16px;
	cursor: pointer;
}
.gc-delete {
	display: flex;
	align-items: center;
	margin-left: auto;
	cursor: pointer;
}
.gc-delete .el-image {
	width: 16px;
	height: 16px;
	margin-right: 4px;
}
.gc-delete span {
	font-size: 14px;
	color: #FC3C3C;
}
.gc-body {
	display: flex;
	align-items: flex-start;
	margin-top: 16px;
}
.gc-img {
	width: 80px;
	height: 80px;
	border-radius: 6px;
	flex-shrink: 0;
	cursor: pointer;
}
.gc-info {
	margin-left: 12px;
}
.gc-name {
	font-size: 14px;
	color: #333;
	margin-bottom: 8px;
}
.gc-size {
	font-size: 14px;
	color: #7A7A7A;
	margin-bottom: 6px;
}
.gc-meta {
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #7A7A7A;
}
.meta-dot {
	width: 4px;
	height: 4px;
	margin: 0 10px;
}

/* ===== 收件人/物流方案（左右两列） ===== */
.recipient-row,
.logistics-row {
	// display: flex;
	// align-items: flex-start;
	margin-bottom: 20px;
}
.select-box {
	width: 118px;
	height: 50px;
	border: 1px solid #0096FF;
	border-radius: 4px;
	text-align: center;
	line-height: 50px;
	font-size: 16px;
	font-weight: 500;
	color: #0096FF;
	cursor: pointer;
	flex-shrink: 0;
	margin-right: 32px;
	margin-bottom: 24px;
}

.address-card {
	// width: 752px;
	height: 112px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 4px;
	padding: 16px;
	box-sizing: border-box;
	position: relative;
}
.addr-icon {
	width: 20px;
	height: 20px;
	position: absolute;
	top: 16px;
	left: 16px;
}
.addr-name {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	margin-left: 28px;
}
.addr-phone {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	margin-left: 8px;
}
.addr-tag {
	position: absolute;
	top: 14px;
	right: 16px;
	width: 72px;
	height: 26px;
	background: #FFEDED;
	border-radius: 4px;
	text-align: center;
	line-height: 26px;
	font-size: 12px;
	color: #FF4747;
}
.addr-point {
	font-size: 14px;
	color: #333;
	margin-top: 10px;
	margin-left: 0;
}
.addr-detail {
	display: flex;
	align-items: center;
	margin-top: 6px;
	margin-left: 0;
}
.addr-country {
	font-size: 14px;
	color: #0096FF;
}
.addr-street {
	font-size: 14px;
	color: #999;
	margin-left: 8px;
}

/* 物流方案卡片 */
.logistics-card {
	// width: 748px;
	height: 112px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 8px;
	padding: 16px 20px;
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	position: relative;
}
.log-img {
	width: 80px;
	height: 80px;
	border-radius: 6px;
	flex-shrink: 0;
	cursor: pointer;
}
.log-body {
	margin-left: 12px;
	flex: 1;
}
.log-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
}
.log-meta {
	display: flex;
	align-items: center;
	margin-top: 8px;
}
.log-duration {
	font-size: 14px;
	color: #7A7A7A;
}
.meta-sep {
	width: 1px;
	height: 10px;
	margin: 0 10px;
	background: #EAEAEA;
}
.log-weight {
	font-size: 14px;
	color: #7A7A7A;
}
.log-sub {
	font-size: 14px;
	color: #7A7A7A;
	margin-top: 8px;
}
.log-price-area {
	text-align: right;
}
.log-price {
	color: #FC3C3C;
}
.log-psymbol {
	font-size: 12px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.log-pvalue {
	font-size: 20px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}
.log-plabel {
	font-size: 12px;
	color: #FC2933;
	margin-top: 2px;
}
.log-detail {
	position: absolute;
	bottom: 16px;
	right: 20px;
	font-size: 14px;
	color: #0096FF;
	cursor: pointer;
}

/* ===== 运输信息 ===== */
.transport-row {
	display: flex;
	margin-bottom: 24px;
}
.transport-item {
	display: flex;
	align-items: center;
	margin-right: 40px;
}
.transport-item:last-child {
	margin-right: 0;
}
.tp-label {
	font-size: 16px;
	color: #333;
	white-space: nowrap;
	margin-right: 16px;
}
.tp-label-red {
	color: #FC3C3C;
}
.tp-options {
	display: flex;
	align-items: center;
	width: 382px;
	height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	padding: 0 16px;
	box-sizing: border-box;
}
.tp-radio {
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-right: 32px;
	position: relative;
}
.tp-radio:last-child {
	margin-right: 0;
}
.tp-radio .el-image {
	width: 22px;
	height: 22px;
}
.radio-inner {
	position: absolute;
	left: 4px;
	top: 4px;
	width: 14px;
	height: 14px;
}
.tp-radio span {
	font-size: 16px;
	color: #333;
	margin-left: 8px;
}
.tp-select-wrap {
	width: 362px;
	height: 50px;
	::v-deep .el-input__inner {
		height: 100%!important;
	}
	::v-deep .el-input {
		height: 100%;
	}
	::v-deep .el-select {
		width: 100%;
		height: 100%;
	}
}
.tp-select {
	width: 100%;
	height: 50px;
}
.tp-select ::v-deep .el-input__inner {
	height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 16px;
	color: #999;
}

/* ===== 备注 ===== */
.remark-row {
	display: flex;
	align-items: center;
	margin-bottom: 24px;
}
.remark-label {
	font-size: 16px;
	color: #333;
	white-space: nowrap;
	margin-right: 16px;
}
.remark-input-wrap {
	flex: 1;
}
.remark-input ::v-deep .el-input__inner {
	height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 16px;
	color: #333;
	padding-left: 24px;
}
.remark-input ::v-deep .el-input__inner::placeholder {
	color: #C6C6C6;
}

/* ===== 下单按钮 ===== */
.submit-row {
	display: flex;
	justify-content: flex-end;
}
.order-btn {
	width: 184px;
	height: 60px;
	background: #0096FF;
	border-radius: 10px;
	color: #fff;
	font-size: 18px;
	font-weight: 500;
	text-align: center;
	line-height: 60px;
	cursor: pointer;
	transition: background 0.3s;
}
.order-btn:hover {
	background: #33ABFF;
}

/* ===================================================================
   添加货物弹窗 (Figma 30934_7945)
   =================================================================== */
.popup-header {
	height: 69px;
	display: flex;
	align-items: center;
	background: #F8f8f8;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
}
.popup-title {
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
}
.popup-body {
	background: #fff;
	padding: 24px;
}
/* 仓库选项卡 */
.popup-tabs {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	border-bottom: 1px solid #F5F5F5;
	margin-bottom: 24px;
}
.popup-tab {
	font-size: 16px;
	font-weight: 400;
	color: #7D7D89;
	cursor: pointer;
	white-space: nowrap;
	padding: 0 20px;
	padding-bottom: 12px;
	position: relative;
	margin-right: 12px;
	transition: color 0.2s;
	&::after {
		position: absolute;
		content: '';
		width: 0%;
		height: 4px;
		background: #0096FF;
		border-radius: 4px;
		left: 50%;
		transform: translateX(-50%);
		bottom: 0;
		transition: 0.3s;
	}
	&:hover { color: #0096FF; }
}
.popup-tab.popup-tab-active {
	color: #0096FF;
	font-weight: bold;
	&::after {
		width: 40%;
	}
}
.popup-grid {
	display: flex;
	flex-wrap: wrap;
	min-height: 200px;
}
.popup-empty {
	width: 100%;
	padding: 60px 0;
	text-align: center;
	font-size: 14px;
	color: #999;
}

/* ========== 地址选择弹窗 ========== */
.addr-list-wrap {
	background: #fff;
	padding: 24px;
	min-height: 240px;
	max-height: 540px;
	overflow-y: auto;
}
.addr-empty {
	width: 100%;
	padding: 80px 0;
	text-align: center;
	font-size: 14px;
	color: #999;
}
.addr-pick-card {
	display: flex;
	align-items: flex-start;
	padding: 20px 24px;
	border: 1px solid #EDEDED;
	border-radius: 8px;
	background: #FAFAFA;
	margin-bottom: 16px;
	cursor: pointer;
	transition: all 0.2s;
}
.addr-pick-card:hover {
	border-color: #0096FF;
	background: #F0F8FF;
}
.addr-pick-card:last-child {
	margin-bottom: 0;
}
.apc-icon {
	width: 40px;
	height: 40px;
	flex-shrink: 0;
	margin-right: 16px;
}
.apc-body {
	flex: 1;
	min-width: 0;
}
.apc-name {
	display: flex;
	align-items: center;
	font-size: 16px;
	font-weight: bold;
	color: #333;
	margin-bottom: 6px;
}
.apc-tag {
	display: inline-block;
	font-size: 12px;
	font-weight: normal;
	padding: 2px 8px;
	border-radius: 4px;
	margin-left: 12px;
	line-height: 1.4;
}
.apc-tag-delivery {
	background: #E7F6FF;
	color: #0096FF;
}
.apc-tag-pickup {
	background: #FFF2E5;
	color: #FA8C16;
}
.apc-selected-flag {
	margin-left: 12px;
	font-size: 12px;
	font-weight: normal;
	color: #0096FF;
	background: #E7F6FF;
	padding: 2px 8px;
	border-radius: 4px;
}
.apc-contact {
	font-size: 14px;
	color: #666;
	margin-bottom: 6px;
}
.apc-contact span {
	margin-right: 16px;
}
.apc-addr {
	font-size: 14px;
	color: #999;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.apc-country {
	color: #0096FF;
	margin-right: 8px;
}

/* ========== 收件人卡片空状态 ========== */
.address-card-empty {
	justify-content: center;
	color: #999;
	font-size: 14px;
	cursor: pointer;
}
.address-card-empty .addr-empty-text {
	color: #999;
}
.addr-tag-delivery {
	background: #E7F6FF;
	color: #0096FF;
}
.addr-tag-pickup {
	background: #FFF2E5;
	color: #FA8C16;
}

/* ========== 物流方案选择弹窗 ========== */
.wl-list-wrap {
	background: #fff;
	padding: 24px;
	max-height: 540px;
	overflow-y: auto;
}
.wl-empty {
	width: 100%;
	padding: 60px 0;
	text-align: center;
	font-size: 14px;
	color: #999;
}
.wl-card {
	display: flex;
	align-items: flex-start;
	padding: 16px 20px;
	border: 1px solid #EDEDED;
	border-radius: 8px;
	background: #FAFAFA;
	margin-bottom: 14px;
	cursor: pointer;
	transition: all 0.2s;
	position: relative;
}
.wl-card:hover {
	border-color: #0096FF;
	background: #F0F8FF;
}
.wl-card:last-child {
	margin-bottom: 0;
}
.wl-card-active {
	border-color: #0096FF;
	background: #E7F6FF;
}
.wlc-img {
	width: 70px;
	height: 70px;
	border-radius: 6px;
	flex-shrink: 0;
}
.wlc-body {
	flex: 1;
	margin-left: 14px;
	min-width: 0;
}
.wlc-name {
	font-size: 15px;
	font-weight: 500;
	color: #333;
	display: flex;
	align-items: center;
}
.wlc-selected {
	margin-left: 10px;
	font-size: 12px;
	font-weight: normal;
	color: #0096FF;
	background: #fff;
	padding: 2px 8px;
	border-radius: 4px;
	border: 1px solid #0096FF;
}
.wlc-meta {
	display: flex;
	align-items: center;
	margin-top: 6px;
	font-size: 13px;
	color: #7A7A7A;
}
.wlc-meta span {
	margin-right: 10px;
}
.wlc-mode {
	font-size: 13px;
	color: #7A7A7A;
	margin-top: 6px;
}
.wlc-price-area {
	text-align: right;
	flex-shrink: 0;
}
.wlc-price {
	color: #FC3C3C;
}
.wlc-psymbol {
	font-size: 12px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.wlc-pvalue {
	font-size: 20px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}
.wlc-plabel {
	font-size: 12px;
	color: #FC2933;
	margin-top: 2px;
}

/* 物流方案卡片空状态 */
.logistics-card-empty {
	justify-content: center;
	color: #999;
	font-size: 14px;
	cursor: pointer;
}
.log-empty-text {
	color: #999;
}

/* 确认按钮禁用态（沿用项目内按钮体系） */
.btn-disabled {
	background: #B5E1FF !important;
	cursor: not-allowed;
	pointer-events: none;
}
.popup-card {
	width: 603px;
	height: 156px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 12px;
	padding: 20px 24px;
	box-sizing: border-box;
	cursor: pointer;
	margin-right: 24px;
	margin-bottom: 24px;
	transition: background 0.3s, border-color 0.3s;
}
.popup-card:nth-child(even) {
	margin-right: 0;
}
.popup-card.popup-card-active {
	background: #0096FF;
	border-color: #0096FF;
}

.pc-top {
	display: flex;
	align-items: center;
}
.pc-checkbox {
	width: 20px;
	height: 20px;
	border: 2px solid #D9D9D9;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
	flex-shrink: 0;
	transition: all 0.3s;
	background: #fff;
	box-sizing: border-box;
}
.pc-checkbox.pc-checked {
	background: #0096FF;
	border-color: #0096FF;
}
.popup-card-active .pc-checkbox {
	border-color: rgba(255,255,255,0.6);
	background: rgba(255,255,255,0.2);
}
.popup-card-active .pc-checkbox.pc-checked {
	background: #fff;
	border-color: #fff;
}
.pc-check-mark {
	color: #fff;
	font-size: 14px;
	font-weight: bold;
	line-height: 1;
}
.popup-card-active .pc-check-mark {
	color: #0096FF;
}
.pc-check-icon {
	width: 20px;
	height: 20px;
}
.pc-tracking {
	font-size: 14px;
	color: #333;
	transition: color 0.3s;
}
.popup-card-active .pc-tracking {
	color: #fff;
}
.pc-copy {
	font-size: 14px;
	color: #0096FF;
	margin-left: 16px;
	cursor: pointer;
	transition: color 0.3s;
}
.popup-card-active .pc-copy {
	color: #fff;
}

.pc-body {
	display: flex;
	align-items: flex-start;
	margin-top: 16px;
}
.pc-img {
	width: 80px;
	height: 80px;
	border-radius: 6px;
	flex-shrink: 0;
	cursor: pointer;
}
.pc-info {
	margin-left: 12px;
}
.pc-name {
	font-size: 14px;
	color: #333;
	margin-bottom: 8px;
	transition: color 0.3s;
}
.popup-card-active .pc-name {
	color: #fff;
}
.pc-size {
	font-size: 14px;
	color: #7A7A7A;
	margin-bottom: 6px;
	transition: color 0.3s;
}
.popup-card-active .pc-size {
	color: #fff;
}
.pc-meta {
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #7A7A7A;
	transition: color 0.3s;
}
.popup-card-active .pc-meta {
	color: #fff;
}
.pc-dot {
	width: 4px;
	height: 4px;
	margin: 0 10px;
}

.popup-footer {
	display: flex;
	justify-content: flex-end;
	padding: 16px 24px 24px;
	background: #fff;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
}
.popup-btn {
	width: 120px;
	height: 44px;
	border-radius: 6px;
	text-align: center;
	line-height: 44px;
	font-size: 16px;
	cursor: pointer;
	margin-left: 14px;
	transition: background 0.3s;
}
.btn-cancel {
	background: #E9F6FF;
	color: #0096FF;
}
.btn-confirm {
	background: #0096FF;
	color: #fff;
}
.btn-confirm:hover {
	background: #33ABFF;
}
</style>
